import React, { useEffect } from 'react';

export default function Osd(props) {
  const { images, osdInstance, setOsdInstance, isFullScreen, setIsFullScreen } =
    props;

  const initOpenSeadragon = async () => {
    // Split OSD out to download as seperate request in parallel
    const { default: OpenSeadragon } = await import('openseadragon');

    // Apply subpixel rounding to all browsers at rest
    const subPixelRoundingForTransparency =
      OpenSeadragon.SUBPIXEL_ROUNDING_OCCURRENCES.ONLY_AT_REST;

    return OpenSeadragon({
      id: 'viewer__osd',
      crossOriginPolicy: 'Anonymous',
      subPixelRoundingForTransparency,
      sequenceMode: true,
      showSequenceControl: false,
      showHomeControl: false,
      showZoomControl: false,
      showFullPageControl: false,
      visibilityRatio: 0.3,
      tileSources: images.map((image) => image.url),
    });
  };

  useEffect(async () => {
    const osd = await initOpenSeadragon();
    osd.addOnceHandler('open', () => {
      if (!osdInstance) {
        const viewerEl = osd.element.parentElement;
        const osdOpenButton = document.querySelector('#osd-open');
        // This is the only "way in" to the viewer
        osdOpenButton.addEventListener('click', () => {
          // If fullscreen API is available use that, otherwise rely on CSS
          if ('requestFullscreen' in viewerEl) {
            viewerEl.requestFullscreen();
          }
          setIsFullScreen(true);
        });
      }
      setOsdInstance(osd);
    });
  }, []);

  useEffect(() => {
    if (isFullScreen) {
      osdInstance.element.querySelector('.openseadragon-canvas').focus();
      setTimeout(() => {
        osdInstance.element.querySelector('.openseadragon-canvas').focus();
      }, 0);
    }
  }, [osdInstance, isFullScreen]);

  return <div id="viewer__osd" className="viewer__osd"></div>;
}
